<template>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="3" order="2" order-sm="1" class="text-center text-sm-left">
          <v-btn @click="toEquipmentShop" color="success" :block="$vuetify.breakpoint.xsOnly">Zum Equipmentshop</v-btn>
        </v-col>
        <v-col cols="12" sm="6" order="1" order-sm="2" class="text-center">
          <h1 class="text-center">Equipment Auswahl</h1>
        </v-col>
        <v-col cols="12" sm="3" order="3" class="text-center text-sm-right">
          <v-btn @click="toRuneShop" color="success" :block="$vuetify.breakpoint.xsOnly">Zum Runenshop</v-btn>
        </v-col>
      </v-row>
      <v-row>
          <v-col cols="12" class="text-center">
            <user-stats-bar
              :username="$store.state.username"
              :xp-name="$store.state.xp_name ?? 'XP'"
              :xp-value="$store.state.xp ?? 0"
            />
          </v-col>

        <v-col cols="12" md="6" class="text-center">
          <v-img
          v-if="false"
            :src="characterImage"
            max-width="300"
            aspect-ratio="1"
            contain
          />
          <div class="dummy-wrapper">
            <armor-dummy
              :head="equipment.head?.img"
              :torso="equipment.torso?.img"
              :legs="equipment.legs?.img"
              :feets="equipment.feets?.img"
            />
          </div>
        </v-col>

        <v-col cols="12" md="6">
          <v-card outlined>
            <v-card-title>Ausrüstung</v-card-title>
            <v-card-text>
                <v-select
                   v-model="equipment.head"
                   :items="headItems"
                    :item-text="itemText"
                    return-object
                    label="Kopf"
                    outlined
                    clearable
                    :disabled="isCooldownActive('head')"
                />
                <div v-if="equipment.head && equipment.head.slots[0]?.slot_id !== null">
                  <div class="slot-row">
                  <div class="slot-container">
                    <v-tooltip
                      v-for="slot in equipment.head.slots"
                      :key="slot.slot_id"
                      bottom
                      >
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          class="slot"
                          :class="[ `slot-type-${slot.slot_type}`, { 'slot-disabled': isCooldownActive('head') } ]"
                          v-on="on"
                          v-bind="attrs"
                          @click="openRuneDialog('head', slot)"
                          @keydown.enter="openRuneDialog('head', slot)"
                          @keydown.space.prevent="openRuneDialog('head', slot)"
                        >
                        <v-img
                          v-if="slot.rune_id"
                          :src="getItemImage(slot.rune_icon, slot.slot_type, slot.slot_rarity)"
                          max-width="40"
                        />
                        <span v-else class="empty-slot">+</span>
                        </div>
                      </template>
                      <span class="d-block">Slot-Typ: {{ slot.slot_type }}</span>
                      <span class="d-block">Slot-Grad: {{ slot.slot_rarity }}</span>
                    </v-tooltip>
                  </div>
                  <div v-if="isCooldownActive('head')" class="cooldown-text">
                    ⏳ {{ cooldownRemaining('head') }}
                  </div>
                </div>
                </div>
               <v-select
                v-model="equipment.torso"
                :items="torsoItems"
                :item-text="itemText"
                return-object
                label="Torso"
                outlined
                clearable
                :disabled="isCooldownActive('torso')"
              />
                <div v-if="equipment.torso && equipment.torso.slots[0]?.slot_id !== null">
                  <div class="slot-row">
                  <div class="slot-container">
                    <v-tooltip
                      v-for="slot in equipment.torso.slots"
                      :key="slot.slot_id"
                      bottom
                      >
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          class="slot"
                          :class="[ `slot-type-${slot.slot_type}`, { 'slot-disabled': isCooldownActive('torso') } ]"
                          v-on="on"
                          v-bind="attrs"
                          @click="openRuneDialog('torso', slot)"
                          @keydown.enter="openRuneDialog('torso', slot)"
                          @keydown.space.prevent="openRuneDialog('torso', slot)"
                        >
                        <v-img
                          v-if="slot.rune_id"
                          :src="getItemImage(slot.rune_icon, slot.slot_type, slot.slot_rarity)"
                          max-width="40"
                        />
                        <span v-else class="empty-slot">+</span>
                        </div>
                      </template>
                      <span class="d-block">Slot-Typ: {{ slot.slot_type }}</span>
                      <span class="d-block">Slot-Grad: {{ slot.slot_rarity }}</span>
                    </v-tooltip>
                  </div>
                  <div v-if="isCooldownActive('torso')" class="cooldown-text">
                    ⏳ {{ cooldownRemaining('torso') }}
                  </div>
                </div>
                </div>
              <v-select
                v-model="equipment.legs"
                :items="legItems"
                :item-text="itemText"
                return-object
                label="Beine"
                outlined
                clearable
                :disabled="isCooldownActive('legs')"
              />
              <div v-if="equipment.legs && equipment.legs.slots[0]?.slot_id !== null">
                <div class="slot-row">
                  <div class="slot-container">
                    <v-tooltip
                      v-for="slot in equipment.legs.slots"
                      :key="slot.slot_id"
                      bottom
                      >
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          class="slot"
                          :class="[ `slot-type-${slot.slot_type}`, { 'slot-disabled': isCooldownActive('legs') } ]"
                          v-on="on"
                          v-bind="attrs"
                          @click="openRuneDialog('legs', slot)"
                          @keydown.enter="openRuneDialog('legs', slot)"
                          @keydown.space.prevent="openRuneDialog('legs', slot)"
                        >
                        <v-img
                          v-if="slot.rune_id"
                          :src="getItemImage(slot.rune_icon, slot.slot_type, slot.slot_rarity)"
                          max-width="40"
                        />
                        <span v-else class="empty-slot">+</span>
                        </div>
                      </template>
                      <span class="d-block">Slot-Typ: {{ slot.slot_type }}</span>
                      <span class="d-block">Slot-Grad: {{ slot.slot_rarity }}</span>
                    </v-tooltip>
                  </div>
                  <div v-if="isCooldownActive('legs')" class="cooldown-text">
                    ⏳ {{ cooldownRemaining('legs') }}
                  </div>
                </div>
                </div>
              <v-select
                v-model="equipment.feets"
                 :items="feetItems"
                :item-text="itemText"
                return-object
                label="Schuhe"
                outlined
                clearable
                :disabled="isCooldownActive('feets')"
              />
              <div v-if="equipment.feets && equipment.feets.slots[0]?.slot_id !== null">
                <div class="slot-row">
                  <div class="slot-container">
                    <v-tooltip
                      v-for="slot in equipment.feets.slots"
                      :key="slot.slot_id"
                      bottom
                      >
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          class="slot"
                          :class="[ `slot-type-${slot.slot_type}`, { 'slot-disabled': isCooldownActive('feets') } ]"
                          v-on="on"
                          v-bind="attrs"
                          @click="openRuneDialog('feets', slot)"
                          @keydown.enter="openRuneDialog('feets', slot)"
                          @keydown.space.prevent="openRuneDialog('feets', slot)"
                        >
                        <v-img
                          v-if="slot.rune_id"
                          :src="getItemImage(slot.rune_icon, slot.slot_type, slot.slot_rarity)"
                          max-width="40"
                        />
                        <span v-else class="empty-slot">+</span>
                        </div>
                      </template>
                      <span class="d-block">Slot-Typ: {{ slot.slot_type }}</span>
                      <span class="d-block">Slot-Grad: {{ slot.slot_rarity }}</span>
                    </v-tooltip>
                  </div>
                  <div v-if="isCooldownActive('feets')" class="cooldown-text">
                    ⏳ {{ cooldownRemaining('feets') }}
                  </div>
                </div>
                </div>
            </v-card-text>
            <div v-if="totalBonus() > 0" class="text-subtitle-1 font-weight-bold text-green">
            Set-Bonus aktiv: {{ totalBonus() }} ThoFu-XP extra (4/4 aktiviert)
          </div>
          <div v-else class="text-subtitle-1 font-weight-bold text-red">
            Set-Bonus wird erreicht bei vollständigem Rüstungsset
          </div>
          </v-card>
          <v-btn
                color="success"
                variant="text"
                class="mt-3"
                :block="$vuetify.breakpoint.xsOnly"
                @click="save"
              >
                Save
              </v-btn>
        </v-col>
      </v-row>
      <v-dialog v-model="runeDialog" max-width="640">
  <v-card>
    <v-card-title>
      Rune auswählen
      <template v-if="selectedSlot?.rune_id">
        <v-spacer></v-spacer>
        <v-btn small color="red" variant="text" @click="removeRuneFromDialog">
          Entfernen
        </v-btn>
      </template>
    </v-card-title>

    <v-card-text class="pb-1">
      <v-row dense align="center">
        <v-col cols="12" sm="7" class="d-flex align-center" style="gap: 8px;">
          <span class="text-caption font-weight-medium">Filter:</span>
          <v-btn-toggle v-model="runeFilter" mandatory dense>
            <v-btn value="all" x-small>Alle</v-btn>
            <v-btn value="usable" x-small>Nur passende</v-btn>
          </v-btn-toggle>
        </v-col>
        <v-col cols="12" sm="5">
          <v-select
            v-model="runeSort"
            :items="runeSortOptions"
            item-text="label"
            item-value="value"
            label="Sortierung"
            dense
            outlined
            hide-details
          />
        </v-col>
      </v-row>
      <div class="d-flex flex-wrap mt-2" style="gap: 6px;">
        <v-chip x-small label color="#9147ff" dark>
          <v-icon x-small left>mdi-check-circle</v-icon>Ausgewählt
        </v-chip>
        <v-chip x-small label color="success" dark>
          <v-icon x-small left>mdi-check</v-icon>Nutzbar
        </v-chip>
        <v-chip x-small label color="warning" dark>
          <v-icon x-small left>mdi-lock</v-icon>Eingesetzt
        </v-chip>
        <v-chip x-small label color="error" dark>
          <v-icon x-small left>mdi-shape-outline</v-icon>Falscher Typ
        </v-chip>
        <v-chip x-small label color="orange darken-2" dark>
          <v-icon x-small left>mdi-arrow-up-circle</v-icon>Grad zu hoch
        </v-chip>
      </div>
    </v-card-text>

    <v-divider/>

    <v-card-text style="max-height: 60vh; overflow-y: auto; padding-top: 0;">
      <v-list>
        <v-list-item
          v-for="rune in filteredRunes"
          :key="rune.id"
          @click="selectRune(rune)"
          :class="runeItemClass(rune)"
        >
          <v-list-item-avatar size="48">
            <v-img :src="getItemImage(rune.icon, rune.type, rune.rarity)"/>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="d-flex align-center flex-wrap" style="gap: 6px;">
              {{ rune.name }}
              <v-chip x-small label :color="runeStatusColor(rune)" dark>
                <v-icon x-small left>{{ runeStatusIcon(rune) }}</v-icon>
                {{ runeStatusLabel(rune) }}
              </v-chip>
            </v-list-item-title>
            <v-list-item-subtitle>{{ rune.description }}</v-list-item-subtitle>
            <v-list-item-subtitle>Runentype: {{ rune.type }}</v-list-item-subtitle>
            <v-list-item-subtitle>Runengrad: {{ rune.rarity }}</v-list-item-subtitle>
            <v-list-item-subtitle class="mt-4">
              <strong>Runen Effekte:</strong>
            </v-list-item-subtitle>
            <div
              v-for="effect in rune.effects"
              :key="effect.id"
              class="mb-3 pa-2 rounded"
              style="background: rgba(0,0,0,0.05);"
            >
              <div class="font-weight-bold text-subtitle-2">
                {{ effect.name }}
              </div>
              <div
                v-for="attr in getVisibleAttributes(effect)"
                :key="attr.index"
                class="text-body-2"
              >
                {{ attr.label }}: {{ formatAttr(effect, attr.index) }}
              </div>
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</v-dialog>

    </v-container>
  </template>

<script>

import BackendService from '@/services/BackendService';
import ArmorDummy from '@/components/ArmorDummy.vue';
import UserStatsBar from '@/components/UserStatsBar.vue';
import { getUnit } from '@/utils/runeUnits';

export default {
  name: 'EquipmentSelection',
  components: {
    ArmorDummy,
    UserStatsBar,
  },
  data: () => ({
    selectedHeadItem: null,
    sendData: {},
    allItems: [],
    characterImage: null,
    now: Date.now(),
    timer: null,
    loadingEquipment: false,
    equipment: {
      head: null,
      torso: null,
      legs: null,
      feets: null,
    },
    runeDialog: false,
    selectedSlot: null,
    selectedPart: null,
    allRunes: [],
    runeFilter: 'all',
    runeSort: 'usable_first',
    runeSortOptions: [
      { label: 'Nutzbare zuerst', value: 'usable_first' },
      { label: 'Name (A–Z)', value: 'name' },
      { label: 'Grad ↑', value: 'rarity_asc' },
      { label: 'Grad ↓', value: 'rarity_desc' },
      { label: 'Typ', value: 'type' },
    ],
  }),
  mounted() {
    this.timer = setInterval(() => {
      this.now = Date.now();
    }, 1000);
    this.loadInstance(this.$route.params.id);
  },
  beforeRouteUpdate(to, from, next) {
    this.loadInstance(to.params.id);
    next();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  computed: {
    headItems() {
      return this.allItems.filter((item) => item.position === 'head');
    },
    torsoItems() {
      return this.allItems.filter((item) => item.position === 'torso');
    },
    legItems() {
      return this.allItems.filter((item) => item.position === 'legs');
    },
    feetItems() {
      return this.allItems.filter((item) => item.position === 'feets');
    },
    filteredRunes() {
      let runes = [...this.allRunes];

      if (this.runeFilter === 'usable') {
        runes = runes.filter((r) => (r.rune_used !== 1 || r.id === this.selectedSlot?.rune_id)
          && r.type === this.selectedSlot?.slot_type
          && r.rarity <= this.selectedSlot?.slot_rarity);
      }

      switch (this.runeSort) {
        case 'rarity_asc':
          runes.sort((a, b) => a.rarity - b.rarity);
          break;
        case 'rarity_desc':
          runes.sort((a, b) => b.rarity - a.rarity);
          break;
        case 'type':
          runes.sort((a, b) => a.type.localeCompare(b.type));
          break;
        case 'usable_first': {
          const order = {
            selected: 0, usable: 1, 'in-use': 2, 'wrong-type': 3, 'too-high': 4,
          };
          runes.sort((a, b) => (order[this.getRuneStatus(a)] ?? 5) - (order[this.getRuneStatus(b)] ?? 5));
          break;
        }
        default:
          runes.sort((a, b) => a.name.localeCompare(b.name));
      }

      return runes;
    },
    headCooldownActive() {
      if (!this.equipment.head || !this.equipment.head.looked) return false;
      return new Date(this.equipment.head.looked).getTime() > this.now;
    },
    headCooldownRemaining() {
      if (!this.headCooldownActive) return null;

      const end = new Date(this.equipment.head.looked).getTime();
      const diff = Math.max(0, Math.floor((end - this.now) / 1000));

      const m = Math.floor(diff / 60);
      const s = diff % 60;

      return `${m}m ${s < 10 ? `0${s}` : s}s`;
    },
  },
  methods: {
    isCooldownActive(part) {
      const item = this.equipment[part];
      if (!item || !item.looked) return false;
      return new Date(item.looked).getTime() > this.now;
    },
    cooldownRemaining(part) {
      const item = this.equipment[part];
      if (!item || !item.looked) return null;

      const end = new Date(item.looked).getTime();
      const diff = Math.max(0, Math.floor((end - this.now) / 1000));

      const h = Math.floor(diff / 3600);
      const m = Math.floor((diff % 3600) / 60);
      const s = diff % 60;

      const paddedM = m.toString().padStart(2, '0');
      const paddedS = s.toString().padStart(2, '0');

      return `${h}h ${paddedM}m ${paddedS}s`;
    },
    hasFullSet() {
      const {
        head, torso, legs, feets,
      } = this.equipment;

      console.log('HEAD SET:', head);
      console.log('TORSO SET:', torso?.set);
      console.log('LEGS SET:', legs?.set);
      console.log('FEETS SET:', feets?.set);

      if (!head || !torso || !legs || !feets) return false;

      const { set } = head;
      return (
        torso.set === set
        && legs.set === set
        && feets.set === set
      );
    },
    totalBonus() {
      if (!this.hasFullSet()) return 0;
      return (
        (this.equipment.head?.bonus || 0)
        + (this.equipment.torso?.bonus || 0)
        + (this.equipment.legs?.bonus || 0)
        + (this.equipment.feets?.bonus || 0)
      );
    },
    hasAttr1(effect) {
      return (
        effect.attribute1min !== undefined
        && effect.attribute1max !== undefined
        && effect.attribute1min !== effect.attribute1max
      );
    },
    hasAttr2(effect) {
      return (
        effect.attribute2min !== undefined
        && effect.attribute2max !== undefined
        && effect.attribute2min !== effect.attribute2max
      );
    },
    getUnit(slug, index) {
      return getUnit(this.$store.state, slug, index);
    },
    formatAttr(effect, index) {
      if (this.isCombined(effect)) {
        const unit2 = this.getUnit(effect.slug, 2);
        return `${effect.attribute1} % Chance auf ${effect.attribute2}${unit2}`;
      }

      const value = effect[`attribute${index}`];
      return `${value}${this.getUnit(effect.slug, index)}`;
    },
    getVisibleAttributes(effect) {
      // Spezialfall: luck_loyalty → nur ein kombinierter Effekt
      if (effect.slug === 'luck_loyalty') {
        return [{ index: 1, label: 'Effekt' }];
      }

      const attrs = [];

      if (this.hasAttr1(effect)) {
        attrs.push({ index: 1, label: 'Effekt' });
      }

      if (this.hasAttr2(effect)) {
        attrs.push({ index: 2, label: 'Effekt' });
      }

      return attrs;
    },
    isCombined(effect) {
      return (
        effect.attribute1min !== effect.attribute1max
        && effect.attribute2min !== effect.attribute2max
      );
    },
    getItemImage(path, type, rarity) {
      if (path === null || path === '') {
        console.log('Rune');
        console.log(type);
        console.log(rarity);
        return this.getDefaultRuneImage(type, rarity);
      }
      if (path.startsWith('/img/Custom_Logo') || path.startsWith(`${process.env.VUE_APP_BACKENDSERVICE_BASEURL}`)) {
        return path;
      }
      return `${process.env.VUE_APP_BACKENDSERVICE_BASEURL}img/${path}`;
    },
    getDefaultRuneImage(type, rarity) {
      switch (`${type}_${rarity}`) {
        case 'Normal_1': return '/img/forge_rune/Runestone_Normal_1.png';
        case 'Normal_2': return '/img/forge_rune/Runestone_Normal_2.png';
        case 'Normal_3': return '/img/forge_rune/Runestone_Normal_3.png';
        case 'Bonus_1': return '/img/forge_rune/Runestone_Bonus_1.png';
        case 'Bonus_2': return '/img/forge_rune/Runestone_Bonus_2.png';
        case 'Bonus_3': return '/img/forge_rune/Runestone_Bonus_3.png';
        case 'Event_1': return '/img/forge_rune/Runestone_Event_1.png';
        case 'Event_2': return '/img/forge_rune/Runestone_Event_2.png';
        case 'Event_3': return '/img/forge_rune/Runestone_Event_3.png';
        default: return '/img/Custom_Logo/ThoFu_Bot_Logo_transparent_text_Crop.png';
      }
    },
    loadInstance(id) {
      // Reset so the previous instance's equipment/runes never leak into the new one.
      this.allItems = [];
      this.allRunes = [];
      this.equipment = {
        head: null, torso: null, legs: null, feets: null,
      };
      this.sendData = { id, username: this.$store.state.username };
      const request = this.$store.state.logged_in === true
        ? this.loadEquipment()
        : BackendService.initalEquipmentList(this.sendData);
      Promise.resolve(request).finally(() => {
        this.$store.dispatch('refreshStatus');
      });
    },
    loadEquipment() {
      return BackendService.loadEquipmentList(this.sendData).then((data) => {
        const equipped = data.data.equipped_items;
        const equ = data.data.equipment;
        const grouped = {};
        const grouped1 = {};
        equipped.forEach((row) => {
          if (!grouped[row.id]) {
            grouped[row.id] = {
              id: row.id,
              position: row.position,
              name: row.name,
              set: row.set,
              bonus: row.bonus,
              img: row.img,
              looked: row.looked,
              slots: [],
            };
          }
          grouped[row.id].slots.push({
            slot_id: row.slot_id,
            slot_type: row.slot_type,
            slot_rarity: row.slot_rarity,
            rune_id: row.rune_id,
            rune_name: row.rune_name,
            rune_type: row.rune_type,
            rune_rarity: row.rune_rarity,
            rune_description: row.rune_description,
            rune_icon: row.rune_icon,
          });
        });
        equ.forEach((row) => {
          if (!grouped1[row.id]) {
            grouped1[row.id] = {
              id: row.id,
              position: row.position,
              name: row.name,
              set: row.set,
              bonus: row.bonus,
              img: row.img,
              looked: row.looked,
              slots: [],
            };
          }
          if (row.slot_id !== null) {
            grouped1[row.id].slots.push({
              slot_id: row.slot_id,
              slot_type: row.slot_type,
              slot_rarity: row.slot_rarity,
              rune_id: null,
              rune_name: null,
              rune_type: null,
              rune_rarity: null,
              rune_description: null,
              rune_icon: null,
            });
          }
        });
        const items = Object.values(grouped);
        this.allRunes = data.data.allrunes;
        this.allItems = Object.values(grouped1);
        this.loadingEquipment = true;
        this.equipment.head = items.find((i) => i.position === 'head') ?? null;
        this.equipment.torso = items.find((i) => i.position === 'torso') ?? null;
        this.equipment.legs = items.find((i) => i.position === 'legs') ?? null;
        this.equipment.feets = items.find((i) => i.position === 'feets') ?? null;
        this.$nextTick(() => {
          this.loadingEquipment = false;
        });
      }).catch(() => {});
    },
    onPartChange(part, newItem, oldItem) {
      const oldSlots = oldItem?.slots || [];

      oldSlots.forEach((slot) => {
        if (slot.rune_id) {
          const rune = this.allRunes.find((r) => r.id === slot.rune_id);
          if (rune) this.$set(rune, 'rune_used', 0);
        }
      });

      if (newItem) {
        this.equipment[part].slots = newItem.slots.map((s) => ({
          ...s,
          rune_id: null,
          rune_icon: null,
          rune_name: null,
          rune_type: s.slot_type,
        }));
      }
    },
    removeRuneFromDialog() {
      const slot = this.selectedSlot;

      const removedRuneId = slot.rune_id;

      // Slot leeren
      Object.assign(slot, {
        rune_id: null,
        rune_name: null,
        rune_icon: null,
        rune_type: null,
      });

      // Rune im Inventar wieder freigeben
      const rune = this.allRunes.find((r) => r.id === removedRuneId);
      if (rune) {
        this.$set(rune, 'rune_used', 0);
      }

      this.runeDialog = false;
    },
    openRuneDialog(part, slot) {
      this.selectedPart = part;
      this.selectedSlot = slot;
      this.runeDialog = true;
    },
    selectRune(rune) {
      console.log('Select Rune');
      console.log(rune);
      const slot = this.selectedSlot;

      if (slot.rune_id && slot.rune_id !== rune.id) {
        const oldRune = this.allRunes.find((r) => r.id === slot.rune_id);
        if (oldRune) oldRune.rune_used = 0;
      }

      if (rune.rune_used === 1 && rune.id !== slot.rune_id) {
        return;
      }

      Object.assign(slot, {
        rune_id: rune.id,
        rune_name: rune.name,
        rune_icon: rune.icon,
        rune_type: rune.type,
        rune_description: rune.description,
      });

      const newRune = this.allRunes.find((r) => r.id === rune.id);
      if (newRune) this.$set(newRune, 'rune_used', 1);
      console.log(slot);
      this.runeDialog = false;
    },
    toRuneShop() {
      this.$router.push({
        name: 'rune_shop',
        params: { id: this.$route.params.id },
      });
    },
    getRuneStatus(rune) {
      if (rune.id === this.selectedSlot?.rune_id) return 'selected';
      if (rune.rune_used === 1) return 'in-use';
      if (rune.type !== this.selectedSlot?.slot_type) return 'wrong-type';
      if (rune.rarity > this.selectedSlot?.slot_rarity) return 'too-high';
      return 'usable';
    },
    runeItemClass(rune) {
      return `rune-status-${this.getRuneStatus(rune)}`;
    },
    runeStatusColor(rune) {
      const colors = {
        selected: '#9147ff',
        usable: 'success',
        'in-use': 'warning',
        'wrong-type': 'error',
        'too-high': 'orange darken-2',
      };
      return colors[this.getRuneStatus(rune)] ?? 'grey';
    },
    runeStatusIcon(rune) {
      const icons = {
        selected: 'mdi-check-circle',
        usable: 'mdi-check',
        'in-use': 'mdi-lock',
        'wrong-type': 'mdi-shape-outline',
        'too-high': 'mdi-arrow-up-circle',
      };
      return icons[this.getRuneStatus(rune)] ?? 'mdi-help';
    },
    runeStatusLabel(rune) {
      const labels = {
        selected: 'Ausgewählt',
        usable: 'Nutzbar',
        'in-use': 'Eingesetzt',
        'wrong-type': 'Falscher Typ',
        'too-high': 'Grad zu hoch',
      };
      return labels[this.getRuneStatus(rune)] ?? '';
    },
    toEquipmentShop() {
      this.$router.push({
        name: 'equipment_shop',
        query: { from: this.$route.params.id },
      });
    },
    itemText(item) {
      if (!this.hasFullSet) {
        return item.name;
      }

      return `${item.name} (+${item.bonus})`;
    },
    save() {
      BackendService.saveEquipment(this.equipment).then(() => {
        this.loadEquipment();
      });
    },
  },
  watch: {
    'equipment.head': function (newItem, oldItem) {
      if (this.loadingEquipment || !oldItem || !oldItem.slots) return;
      this.onPartChange('head', newItem, oldItem);
    },
    'equipment.torso': function (newItem, oldItem) {
      if (this.loadingEquipment || !oldItem || !oldItem.slots) return;
      this.onPartChange('torso', newItem, oldItem);
    },
    'equipment.legs': function (newItem, oldItem) {
      if (this.loadingEquipment || !oldItem || !oldItem.slots) return;
      this.onPartChange('legs', newItem, oldItem);
    },
    'equipment.feets': function (newItem, oldItem) {
      if (this.loadingEquipment || !oldItem || !oldItem.slots) return;
      this.onPartChange('feets', newItem, oldItem);
    },
  },

};
</script>

<style scoped>
.dummy-wrapper {
  transform-origin: top center;
  width: fit-content;
  height: 690px; /* Beispielwert */
  overflow: hidden;
  display: inline-block;
}

@media (max-width: 599px) {
  .dummy-wrapper {
    height: 420px;
  }
}

.rune-status-usable {
  background-color: rgba(76, 175, 80, 0.06);
}

.rune-status-selected {
  background-color: rgba(145, 71, 255, 0.15);
}

.rune-status-in-use {
  opacity: 0.55;
  background-color: rgba(255, 152, 0, 0.08);
  pointer-events: none;
}

.rune-status-wrong-type {
  opacity: 0.5;
  background-color: rgba(244, 67, 54, 0.08);
  pointer-events: none;
}

.rune-status-too-high {
  opacity: 0.5;
  background-color: rgba(255, 109, 0, 0.08);
  pointer-events: none;
}

.slot-container {
  display: flex;
  gap: 10px;
  margin-top: -10px;
  margin-bottom: 25px;
}

.slot-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px; /* Abstand zwischen Slots und Timer */
}

.slot-disabled {
  pointer-events: none; /* 🔥 verhindert Klicks */
  opacity: 0.5;         /* optional: visuelles Feedback */
}

.slot {
  position: relative;
  width: 40px;
  height: 40px;
  border: 2px dashed #aaa;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.cooldown-text {
  font-size: 16px;
  font-weight: bold;
  white-space: nowrap;
  bottom: -4px;
  right: -4px;
  background: rgba(253, 0, 0, 0.75);
  color: #fff;
  padding: 2px 6px;
  border-radius: 6px;
}

.empty-slot {
  font-size: 24px;
  color: #aaa;
}

.slot-type-Event {
  border: 2px solid #ff4d4d; /* Rot */
  box-shadow: 0 0 6px rgba(255, 77, 77, 0.6);
}

.slot-type-Normal {
  border: 2px solid #4da6ff; /* Blau */
  box-shadow: 0 0 6px rgba(77, 166, 255, 0.6);
}

.slot-type-Bonus {
  border: 2px solid #4dff4d; /* Grün */
  box-shadow: 0 0 6px rgba(77, 255, 77, 0.6);
}

.v-list-item {
  align-items: flex-start !important;
}

.v-list-item__avatar {
  align-self: flex-start !important;
}

</style>
